/* Elite Auto Gear - Fit Finder (Year / Make / Model + garage) */
(function () {
  'use strict';
  var C = window.EAGFF_CFG || {};
  var LS = 'eagff_garage_v1';
  var MAX_GARAGE = 10;
  var TYPES = [['car', 'Car/Truck/SUV'], ['moto', 'Motorcycle'], ['ps', 'Powersports'], ['marine', 'Marine']];
  var D = null, IDX = null, loading = null;

  /* ---------- live product index ----------
     templates/collection.eag-index.liquid lists every published product's Fit Finder fields
     (speaker fields + vehicle_fitment), so products added or edited in admin show within minutes
     with no rebuild. Cached per browser session for 10 minutes. If it fails, the bundled files are used. */
  var LIVE_KEY = 'eagff_live_v2', LIVE_TTL = 10 * 60 * 1000;
  function liveIndex() {
    try {
      var c = JSON.parse(sessionStorage.getItem(LIVE_KEY) || 'null');
      if (c && Date.now() - c.t < LIVE_TTL && c.fit && c.sp && c.hu) return Promise.resolve(c);
    } catch (e) {}
    var url = function (p) { return C.root + 'collections/all?view=eag-index&page=' + p; };
    var get = function (p) { return fetch(url(p), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); };
    var work = get(1).then(function (first) {
      var rest = [];
      for (var p = 2; p <= (first.pages || 1); p++) rest.push(get(p));
      return Promise.all(rest).then(function (more) {
        var out = { t: Date.now(), fit: {}, sp: {}, hu: {} };
        [first].concat(more).forEach(function (pg) {
          Object.keys(pg.fit || {}).forEach(function (h) { out.fit[h] = pg.fit[h]; });
          Object.keys(pg.sp || {}).forEach(function (h) { out.sp[h] = pg.sp[h]; });
          Object.keys(pg.hu || {}).forEach(function (h) { out.hu[h] = pg.hu[h]; });
        });
        try { sessionStorage.setItem(LIVE_KEY, JSON.stringify(out)); } catch (e) {}
        return out;
      });
    });
    var timeout = new Promise(function (res) { setTimeout(function () { res(null); }, 8000); });
    return Promise.race([work, timeout]).catch(function () { return null; });
  }
  // Tweeter style: 'd' = dome / OEM-style (factory spots), 'p' = bullet / horn / compression (same rule as the old index build).
  var PRO_TW = /super ?tweeter|bullet|compression|horn|hybrid driver|high[- ]output|epic ?pro|apocalypse at|\b3\.[0-9]\s*["”″]|\b4(\.5)?\s*["”″]/i;
  // custom.head_unit_type value -> [role, chassis] used by the head-unit code below
  var HU_TYPES = {
    'Single DIN': ['head-unit', '1-DIN'], 'Double DIN': ['head-unit', '2-DIN'],
    'Floating screen (single-DIN chassis)': ['floating-head-unit', '1-DIN floating'],
    'Marine / powersports gauge radio': ['marine-powersports-head-unit', null], 'Motorcycle radio': ['motorcycle-head-unit', null],
    'Vehicle radio kit': ['vehicle-radio-kit', null], 'Powersports dash kit': ['powersports-dash-kit', null],
    'Radio interface': ['radio-interface', null], 'Amp interface': ['amp-interface', null],
    'Speaker harness': ['speaker-harness', null], 'Powersports harness': ['powersports-harness', null]
  };
  // head units / radio kits / install parts: rebuilt from the product fields (head_unit_type, screen_size, kit_needed + vehicle_fitment).
  // Vehicle rows with install conditions from the bundled file are kept when the product has them.
  function applyLiveHu(live) {
    if (!live.hu || !Object.keys(live.hu).length) return;
    var old = (HU && HU.products) || {}, out = {};
    Object.keys(live.hu).forEach(function (h) {
      var x = live.hu[h], t = HU_TYPES[x[0]];
      if (!t) return;
      var o = old[h] || {}, v = o.v && o.v.length ? o.v : [];
      if (!v.length && Array.isArray(live.fit[h])) v = live.fit[h].filter(function (r) { return r && r.make && r.model && r.from; })
        .map(function (r) { return [r.type || 'car', r.make, r.model, +r.from, +(r.to || 2027), '']; });
      out[h] = { r: t[0], ch: t[1] || o.ch || null, sc: x[1] ? Number(x[1]) : null, v: v, ra: x[2] || '', cf: o.cf || 'high' };
    });
    HU = { v: 1, products: out };
  }
  function applyLive(d, live) {
    if (!live) return;
    applyLiveHu(live);
    // vehicle-specific products: the live product fields are the source of truth
    var prods = {};
    Object.keys(live.fit).forEach(function (h) {
      var list = live.fit[h];
      if (!Array.isArray(list)) return;
      var rows = list.filter(function (x) { return x && x.make && x.model && x.from; })
        .map(function (x) { return [x.type || 'car', x.make, x.model, +x.from, +(x.to || d.maxYear || 2027), x.body || []]; });
      if (rows.length) prods[h] = rows;
    });
    d.products = prods;
    var veh = {};
    Object.keys(prods).forEach(function (h) {
      prods[h].forEach(function (r) { var k = r[0] + '|' + r[1] + '|' + r[2]; (veh[k] = veh[k] || []).push([h, r[3], r[4], r[5]]); });
    });
    d.vehicles = veh;
    // speakers: rebuilt from the live fields; marine/tower flags kept from the old index when known
    if (SI) {
      var old = SI.products || {}, sp = {};
      Object.keys(live.sp).forEach(function (h) {
        var x = live.sp[h], o = old[h], title = x[6] || '';
        var size = x[1] || '', depth = x[2] ? Number(x[2]) : 0;
        var tw = x[0] === 'Tweeter' ? ((PRO_TW.test(title) || parseFloat(size) > 2 || depth > 2) ? 'p' : 'd') : '';
        sp[h] = [x[0], size, depth, x[3] || '', x[4] || '', o ? o[5] : x[5], o ? o[6] : (/marine/i.test(title) ? 1 : 0), o ? o[7] : (/tower|wake/i.test(title) ? 1 : 0), tw];
      });
      SI.products = sp;
    }
  }

  /* ---------- data ---------- */
  function load() {
    if (!loading) {
      loading = Promise.all([fetch(C.data).then(function (r) { return r.json(); }),
        C.speakerFit ? fetch(C.speakerFit).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : null,
        C.speakerIndex ? fetch(C.speakerIndex).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : null,
        C.vehicles ? fetch(C.vehicles).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : null,
        C.radioFit ? fetch(C.radioFit).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : null,
        C.huIndex ? fetch(C.huIndex).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : null,
        liveIndex()]).then(function (a) {
        var d = a[0]; SP = a[1]; SI = a[2]; var ALL = a[3]; RF = a[4]; HU = a[5];
        applyLive(d, a[6]);
        // Product fields (custom.vehicle_fitment) win over the bundled file for the current product.
        if (C.product && C.productFit && C.productFit.length) {
          d.products[C.product] = C.productFit.map(function (f) { return [f.type, f.make, f.model, f.from, f.to, f.body || []]; });
        }
        D = d; IDX = {};
        Object.keys(d.vehicles).forEach(function (k) {
          var p = k.split('|');
          var t = p[0], mk = p[1], md = p[2];
          IDX[t] = IDX[t] || [];
          IDX[t].push({ key: k, make: mk, model: md, links: d.vehicles[k].slice() });
        });
        if (SP) SP.vehicles.forEach(function (x) {
          var t = x.type || 'car';
          [x.make + '|' + x.model].concat(x.alsoMakeModel || []).forEach(function (mm) {
            var p = mm.split('|'); IDX[t] = IDX[t] || [];
            var e = IDX[t].filter(function (v) { return v.make === p[0] && v.model === p[1]; })[0];
            if (!e) { e = { key: t + '|' + p[0] + '|' + p[1], make: p[0], model: p[1], links: [] }; IDX[t].push(e); }
            e.links.push([null, x.from, x.to, []]);
          });
        });
        // Full make / model / year list (NHTSA vPIC), so every vehicle can be selected.
        if (ALL && ALL.v) Object.keys(ALL.v).forEach(function (t) {
          IDX[t] = IDX[t] || [];
          Object.keys(ALL.v[t]).forEach(function (mk) {
            Object.keys(ALL.v[t][mk]).forEach(function (md) {
              var e = IDX[t].filter(function (v) { return v.make === mk && v.model === md; })[0];
              if (!e) { e = { key: t + '|' + mk + '|' + md, make: mk, model: md, links: [] }; IDX[t].push(e); }
              ALL.v[t][mk][md].forEach(function (yr) { e.links.push([null, yr[0], yr[1], []]); });
            });
          });
        });
        return d;
      });
    }
    return loading;
  }
  function covers(l, y) { return y >= l[1] && y <= l[2]; }
  function knownVehicle(v) {
    return (IDX[v.type] || []).some(function (e) { return e.make === v.make && e.model === v.model && e.links.some(function (l) { return covers(l, v.year); }); });
  }
  function years(t) {
    if (!IDX) return [];
    var s = {};
    (IDX[t] || []).forEach(function (v) { v.links.forEach(function (l) { for (var y = l[1]; y <= l[2]; y++) s[y] = 1; }); });
    return Object.keys(s).map(Number).sort(function (a, b) { return b - a; });
  }
  function makes(t, y) {
    var s = {};
    (IDX[t] || []).forEach(function (v) { if (v.links.some(function (l) { return covers(l, y); })) s[v.make] = 1; });
    return Object.keys(s).sort();
  }
  function models(t, y, mk) {
    return (IDX[t] || []).filter(function (v) {
      return v.make === mk && v.links.some(function (l) { return covers(l, y); });
    }).map(function (v) { return v.model; }).sort();
  }
  function cabs(t, y, mk, md) {
    var v = D.vehicles[t + '|' + mk + '|' + md] || [], s = {};
    v.forEach(function (l) { if (covers(l, y)) (l[3] || []).forEach(function (c) { s[c] = 1; }); });
    var sv = SP && spFor({ type: t, make: mk, model: md, year: y }); if (sv) sv.bodies.forEach(function (b) { s[b] = 1; });
    return Object.keys(s).sort();
  }
  function handlesFor(v) {
    var links = D.vehicles[v.type + '|' + v.make + '|' + v.model] || [], seen = {}, out = [];
    links.forEach(function (l) {
      if (!covers(l, v.year)) return;
      if (v.cab && l[3] && l[3].length && l[3].indexOf(v.cab) < 0) return;
      if (!seen[l[0]]) { seen[l[0]] = 1; out.push(l[0]); }
    });
    return out;
  }
  /* true = fits, false = does not fit, null = product has no fitment data */
  function fits(handle, v) {
    var e = D.products[handle];
    if (!e) return null;
    if (!v) return undefined;
    return e.some(function (f) {
      return f[0] === v.type && f[1] === v.make && f[2] === v.model && v.year >= f[3] && v.year <= f[4] &&
        (!v.cab || !f[5] || !f[5].length || f[5].indexOf(v.cab) >= 0);
    });
  }

  /* ---------- garage ---------- */
  function garage() {
    try { var g = JSON.parse(localStorage.getItem(LS)); if (g && g.list) return g; } catch (e) {}
    return { list: [], active: null };
  }
  function saveGarage(g) { try { localStorage.setItem(LS, JSON.stringify(g)); } catch (e) {} }
  function vid(v) { return [v.type, v.year, v.make, v.model, v.cab || ''].join('|'); }
  function label(v) { return v.year + ' ' + v.make + ' ' + v.model + (v.cab ? ' ' + v.cab : ''); }
  function active() {
    var g = garage();
    return g.list.filter(function (v) { return vid(v) === g.active; })[0] || null;
  }
  function setActive(v) {
    var g = garage(), id = vid(v);
    g.list = g.list.filter(function (x) { return vid(x) !== id; });
    g.list.unshift(v);
    if (g.list.length > MAX_GARAGE) g.list.length = MAX_GARAGE;
    g.active = id;
    saveGarage(g); refresh();
  }
  function selectSaved(id) { var g = garage(); g.active = id; saveGarage(g); refresh(); }
  function removeSaved(id) {
    var g = garage();
    g.list = g.list.filter(function (x) { return vid(x) !== id; });
    if (g.active === id) g.active = null;
    saveGarage(g); refresh();
  }
  function clearActive() { var g = garage(); g.active = null; saveGarage(g); refresh(); }

  /* ---------- helpers ---------- */
  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') el.textContent = attrs[k];
      else if (k === 'html') el.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') el.addEventListener(k.slice(2), attrs[k]);
      else el.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function resultsUrl(v) {
    return C.results + '?t=' + encodeURIComponent(v.type) + '&y=' + v.year + '&mk=' + encodeURIComponent(v.make) +
      '&md=' + encodeURIComponent(v.model) + (v.cab ? '&cab=' + encodeURIComponent(v.cab) : '');
  }

  /* ---------- picker: type tabs + numbered searchable steps ---------- */
  function Picker(root, opts) {
    this.root = root; this.opts = opts || {};
    this.type = (active() && active().type) || 'car';
    this.sel = {};
    this.build();
  }
  Picker.prototype.build = function () {
    var self = this, r = this.root;
    r.innerHTML = '';
    var tabs = h('div', { class: 'eagff-tabs', role: 'tablist' });
    TYPES.forEach(function (t) {
      tabs.appendChild(h('button', {
        type: 'button', role: 'tab', class: 'eagff-tab' + (t[0] === self.type ? ' is-on' : ''),
        'aria-selected': t[0] === self.type ? 'true' : 'false',
        onclick: function () { self.type = t[0]; self.sel = {}; self.build(); }
      }, [h('span', { class: 'eagff-tab-ico', html: ICONS[t[0]] }), t[1]]));
    });
    r.appendChild(tabs);
    this.stepsEl = h('div', { class: 'eagff-steps' });
    r.appendChild(this.stepsEl);
    this.go = h('button', { type: 'button', class: 'eagff-go', disabled: 'disabled', onclick: function () { self.submit(); } },
      [this.opts.goText || 'Find products']);
    r.appendChild(this.go);
    this.render();
  };
  Picker.prototype.render = function () {
    var self = this, s = this.sel, t = this.type;
    this.stepsEl.innerHTML = '';
    var steps = [
      ['year', 'Year', years(t)],
      ['make', 'Make', s.year ? makes(t, s.year) : []],
      ['model', 'Model', s.make ? models(t, s.year, s.make) : []]
    ];
    var cabList = s.model ? cabs(t, s.year, s.make, s.model) : [];
    if (cabList.length) steps.push(['cab', 'Trim / Body', ['All / Not sure'].concat(cabList)]);
    steps.forEach(function (st, i) {
      var enabled = i === 0 || s[steps[i - 1][0]];
      self.stepsEl.appendChild(self.step(i + 1, st[0], st[1], st[2], !enabled));
    });
    var done = s.year && s.make && s.model && (!cabList.length || s.cab !== undefined);
    if (done) this.go.removeAttribute('disabled'); else this.go.setAttribute('disabled', 'disabled');
    this.done = done;
  };
  Picker.prototype.step = function (n, key, name, items, disabled) {
    var self = this, val = this.sel[key];
    var shown = val === null ? 'All / Not sure' : val;
    var wrap = h('div', { class: 'eagff-step' + (disabled ? ' is-off' : '') + (val !== undefined ? ' is-set' : ''), 'data-step': key });
    var btn = h('button', { type: 'button', class: 'eagff-step-btn', 'aria-haspopup': 'listbox', 'aria-expanded': 'false' },
      [h('span', { class: 'eagff-num', text: String(n) }), h('span', { class: 'eagff-bar', text: '|' }),
       h('span', { class: 'eagff-val', text: val !== undefined ? String(shown) : name }),
       h('span', { class: 'eagff-caret', html: '&#9662;' })]);
    if (disabled) btn.disabled = true;
    var pop = h('div', { class: 'eagff-pop', hidden: 'hidden' });
    var search = h('input', { type: 'search', class: 'eagff-search', placeholder: 'Search ' + name.toLowerCase(), 'aria-label': 'Search ' + name });
    var list = h('ul', { class: 'eagff-list', role: 'listbox' });
    function fill(q) {
      list.innerHTML = '';
      var qq = (q || '').toLowerCase();
      var f = items.filter(function (it) { return String(it).toLowerCase().indexOf(qq) >= 0; });
      if (!f.length) list.appendChild(h('li', { class: 'eagff-empty', text: IDX ? 'No matches' : 'Loading...' }));
      f.forEach(function (it) {
        list.appendChild(h('li', { role: 'option', class: 'eagff-opt' + (String(it) === String(shown) ? ' is-on' : ''), tabindex: '-1',
          onclick: function () { self.pick(key, it); } }, [String(it)]));
      });
    }
    search.addEventListener('input', function () { fill(search.value); });
    search.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); var o = list.querySelector('.eagff-opt'); if (o) o.click(); }
      if (e.key === 'Escape') self.closePops();
    });
    pop.appendChild(search); pop.appendChild(list);
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = pop.hidden;
      self.closePops();
      if (open) { fill(''); pop.hidden = false; btn.setAttribute('aria-expanded', 'true'); wrap.classList.add('is-open'); search.focus(); }
    });
    wrap.appendChild(btn); wrap.appendChild(pop);
    return wrap;
  };
  Picker.prototype.closePops = function () {
    this.root.querySelectorAll('.eagff-step').forEach(function (w) {
      w.classList.remove('is-open');
      var p = w.querySelector('.eagff-pop'); if (p) p.hidden = true;
      var b = w.querySelector('.eagff-step-btn'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  };
  Picker.prototype.pick = function (key, val) {
    var s = this.sel, order = ['year', 'make', 'model', 'cab'];
    if (key === 'cab') val = val === 'All / Not sure' ? null : val;
    s[key] = key === 'year' ? Number(val) : val;
    order.slice(order.indexOf(key) + 1).forEach(function (k) { delete s[k]; });
    this.render();
    var next = order[order.indexOf(key) + 1];
    var nb = next && this.stepsEl.querySelector('[data-step="' + next + '"] .eagff-step-btn');
    if (nb && !nb.disabled) nb.click();
    else if (this.done && this.opts.autoSubmit) this.submit();
  };
  Picker.prototype.submit = function () {
    if (!this.done) return;
    var s = this.sel;
    var v = { type: this.type, year: s.year, make: s.make, model: s.model };
    if (s.cab) v.cab = s.cab;
    setActive(v);
    if (this.opts.onDone) this.opts.onDone(v);
  };

  var ICONS = {
    marine: '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M11 3h2v7h6l-2 3H5.5L4 10h7V3zm-7 12h16l-1.6 3.2c-.3.5-.8.8-1.4.8H7c-.6 0-1.1-.3-1.4-.8L4 15zm-1 6c1.3 0 1.9-.6 3-.6s1.7.6 3 .6 1.9-.6 3-.6 1.7.6 3 .6 1.9-.6 3-.6 1.7.6 3 .6v1.4c-1.3 0-1.9-.6-3-.6s-1.7.6-3 .6-1.9-.6-3-.6-1.7.6-3 .6-1.9-.6-3-.6-1.7.6-3 .6V21z"/></svg>',
    car: '<svg viewBox="0 0 50 50" width="20" height="20" fill="currentColor" aria-hidden="true"><g><path d="m46.3 22.1c-5.7-1.5-9.2-1.3-10-1.6-.4-.1 0 0-6.1-3.7-.6-.4-1.4-.6-2.1-.7-6.9-.8-15-.6-20.5 3.7-.3.2-.5.4-.8.4l-3.2 1c-.6.2-1.1.6-1.3 1.1-1.1 1.9-1.5 4.3-.9 6.5.2.9.9 1.5 1.7 1.7l.8.2c0-.3-.1-.5-.1-.8 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 .5-.1 1-.2 1.4h18.3c-.1-.5-.2-.9-.2-1.4 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 .4 0 .8-.1 1.2.8-.4 1.3-1.3 1.3-2.2v-3.1c.1-1.8-1-3.3-2.6-3.7zm-29.4-.1c-.3 0-.6-.1-.8-.4l-2.4-2.9c2.2-.7 4.8-1.1 7.7-1.1l1.2 4.4zm16.4-.1c-.2.1-.3.1-.5.1h-8.1l-1.2-4.3c1.4.1 2.8.2 4.2.3.4 0 .9.2 1.3.4l4.9 3z"/><ellipse cx="10.3" cy="29.8" rx="4.5" ry="4.5"/><circle cx="41.3" cy="29.8" r="4.5"/></g></svg>',
    moto: '<svg viewBox="0 0 467.168 467.168" width="20" height="20" fill="currentColor" aria-hidden="true"><g> <g> <path d="M76.849,210.531C34.406,210.531,0,244.937,0,287.388c0,42.438,34.406,76.847,76.849,76.847 c30.989,0,57.635-18.387,69.789-44.819l18.258,14.078c0,0,134.168,0.958,141.538-3.206c0,0-16.65-45.469,4.484-64.688 c2.225-2.024,5.021-4.332,8.096-6.777c-3.543,8.829-5.534,18.45-5.534,28.558c0,42.446,34.403,76.846,76.846,76.846 c42.443,0,76.843-34.415,76.843-76.846c0-42.451-34.408-76.849-76.843-76.849c-0.697,0-1.362,0.088-2.056,0.102 c5.551-3.603,9.093-5.865,9.093-5.865l-5.763-5.127c0,0,16.651-3.837,12.816-12.167c-3.848-8.33-44.19-58.28-44.19-58.28 s7.146-15.373-7.634-26.261l-7.098,15.371c0,0-18.093-12.489-25.295-10.084c-7.205,2.398-18.005,3.603-21.379,8.884l-3.358,3.124 c0,0-0.95,5.528,4.561,13.693c0,0,55.482,17.05,58.119,29.537c0,0,3.848,7.933-12.728,9.844l-3.354,4.328l-8.896,0.479 l-16.082-36.748c0,0-15.381,4.082-23.299,10.323l1.201,6.24c0,0-64.599-43.943-125.362,21.137c0,0-44.909,12.966-76.37-26.897 c0,0-0.479-12.968-76.367-10.565l5.286,5.524c0,0-5.286,0.479-7.444,3.841c-2.158,3.358,1.2,6.961,18.494,6.961 c0,0,39.153,44.668,69.17,42.032l42.743,20.656l18.975,32.42c0,0,0.034,2.785,0.23,7.045c-4.404,0.938-9.341,1.979-14.579,3.09 C139.605,232.602,110.832,210.531,76.849,210.531z M390.325,234.081c29.395,0,53.299,23.912,53.299,53.299 c0,29.39-23.912,53.294-53.299,53.294c-29.394,0-53.294-23.912-53.294-53.294C337.031,257.993,360.932,234.081,390.325,234.081z M76.849,340.683c-29.387,0-53.299-23.913-53.299-53.295c0-29.395,23.912-53.299,53.299-53.299 c22.592,0,41.896,14.154,49.636,34.039c-28.26,6.011-56.31,11.99-56.31,11.99l3.619,19.933l55.339-2.444 C124.365,322.116,102.745,340.683,76.849,340.683z M169.152,295.835c1.571,5.334,3.619,9.574,6.312,11.394l-24.696,0.966 c1.058-3.783,1.857-7.666,2.338-11.662L169.152,295.835z"/> </g> </g></svg>',
    ps: '<svg viewBox="0 0 60 60" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="m23.412 24.389a1.033 1.033 0 0 0 .918.611h4.67a1 1 0 0 0 1-1v-3.134a6.574 6.574 0 0 1 -1.3.134h-8.29a8.946 8.946 0 0 1 3.002 3.389z"/><path d="m40.017 33.673a10.96 10.96 0 0 1 14.983-2.881v-3.792h-8a7 7 0 0 0 -6.983 6.673z"/><path d="m55 23h-8a11.013 11.013 0 0 0 -11 11v7h2v-7a9.01 9.01 0 0 1 9-9h10.829a3.006 3.006 0 0 0 -2.829-2z"/><path d="m39.376 17.866 4.208 3.605a12.841 12.841 0 0 1 2.528-.426l-5.332-7.622a1.019 1.019 0 0 0 -.82-.423h-1.144a3 3 0 0 1 -1.816 1.816v2.184h.05a3.542 3.542 0 0 1 2.326.866z"/><circle cx="36" cy="12" r="1"/><path d="m5 25h6a15.017 15.017 0 0 1 15 15h8v-6a13 13 0 0 1 7.439-11.733l-3.37-2.887a1.566 1.566 0 0 0 -1.019-.38h-2.11a2.927 2.927 0 0 0 -1.326.311l-1.614.807v3.882a3 3 0 0 1 -3 3h-4.67a3.03 3.03 0 0 1 -2.7-1.713c-2.137-4.214-7.577-4.287-7.63-4.287h-12v1a3 3 0 0 0 3 3z"/><path d="m49 31a9 9 0 1 0 9 9 9.01 9.01 0 0 0 -9-9zm0 14a5 5 0 1 1 5-5 5.006 5.006 0 0 1 -5 5z"/><path d="m11 29a11.01 11.01 0 0 1 10.949 10h2a13.009 13.009 0 0 0 -12.949-12h-4.72l.691 2.775a10.928 10.928 0 0 1 4.029-.775z"/><circle cx="11" cy="40" r="3"/><circle cx="49" cy="40" r="3"/><path d="m11 49a9 9 0 1 0 -9-9 9.01 9.01 0 0 0 9 9zm0-14a5 5 0 1 1 -5 5 5.006 5.006 0 0 1 5-5z"/></svg>'
  };

  /* ---------- modal ---------- */
  var modal = null, modalPicker = null, pending = null;
  function openModal(mode) {
    modal = modal || document.getElementById('EagffModal');
    if (!modal) return Promise.resolve();
    return load().then(function () {
      modal.classList.toggle('is-atc', mode === 'atc');
      showView('main');
      modalPicker = new Picker(modal.querySelector('[data-eagff-picker]'), {
        goText: mode === 'atc' ? 'Done' : mode === 'check' ? 'Check fit' : 'Find products',
        onDone: function (v) {
          if (mode === 'atc') { resumeAtc(); closeModal(); } /* resume first: closeModal drops an un-resumed add */
          else if (mode === 'check') closeModal();
          else window.location.href = resultsUrl(v);
        }
      });
      renderGarage();
      modal.hidden = false;
      document.documentElement.classList.add('eagff-lock');
      var f = modal.querySelector('.eagff-step-btn'); if (f) f.focus();
    });
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('eagff-lock');
    if (pending && !pending.resumed) pending = null;
  }
  function showView(name) {
    modal.querySelectorAll('[data-eagff-view]').forEach(function (v) { v.hidden = v.getAttribute('data-eagff-view') !== name; });
    if (name === 'cant') {
      var p = modalPicker && modalPicker.sel;
      var y = modal.querySelector('[name="contact[Vehicle year]"]');
      if (p && y && p.year && !y.value) y.value = p.year;
      var m = modal.querySelector('[name="contact[Vehicle make]"]');
      if (p && m && p.make && !m.value) m.value = p.make;
    }
  }
  var GARAGE_SHOW = 5, garageAll = false;
  function renderGarage() {
    var box = modal.querySelector('[data-eagff-garage]');
    if (!box) return;
    var g = garage();
    box.innerHTML = '';
    if (!g.list.length) {
      box.appendChild(h('p', { class: 'eagff-garage-empty', text: 'No saved vehicles yet. Pick a vehicle above and it will be saved here.' }));
      return;
    }
    /* first 5 vehicles, the rest behind Show more (the selected vehicle is always shown) */
    var extra = g.list.filter(function (v, i) { return i >= GARAGE_SHOW && vid(v) !== g.active; }).length;
    g.list.forEach(function (v, i) {
      var id = vid(v), on = id === g.active;
      if (!garageAll && i >= GARAGE_SHOW && !on) return;
      box.appendChild(h('div', { class: 'eagff-gv' + (on ? ' is-on' : '') }, [
        h('button', { type: 'button', class: 'eagff-gv-name', onclick: function () {
          selectSaved(id);
          if (modal.classList.contains('is-atc')) { resumeAtc(); closeModal(); } else renderGarage();
        } }, [h('span', { class: 'eagff-radio' }), label(v)]),
        h('a', { class: 'eagff-gv-shop', href: resultsUrl(v), onclick: function () { selectSaved(id); }, text: 'Shop' }),
        h('button', { type: 'button', class: 'eagff-gv-rm', 'aria-label': 'Remove ' + label(v), onclick: function () { removeSaved(id); renderGarage(); }, text: 'Remove' })
      ]));
    });
    if (extra > 0) {
      box.appendChild(h('button', { type: 'button', class: 'eagff-gv-more', 'aria-expanded': garageAll ? 'true' : 'false',
        onclick: function () { garageAll = !garageAll; renderGarage(); },
        text: garageAll ? 'Show less' : 'Show more (' + extra + ')' }));
    }
  }

  /* ---------- speaker fit: sizes per location (eag-speaker-fit.json) + product speaker data ----------
     Data sources are isolated here so they can be swapped (metaobject / API) without touching the UI. */
  var SP = null, SI = null;
  function spFor(v) {
    if (!SP || !v) return null;
    return SP.vehicles.filter(function (x) {
      return (x.type || 'car') === v.type && (x.make === v.make && x.model === v.model || (x.alsoMakeModel || []).indexOf(v.make + '|' + v.model) >= 0) && v.year >= x.from && v.year <= x.to;
    })[0] || null;
  }
  function spBody(sv, v) { return v.cab && sv.bodies.indexOf(v.cab) >= 0 ? v.cab : null; }
  function spLocations(sv, v) {
    var b = spBody(sv, v) || sv.bodies[0];
    return sv.locations.filter(function (l) { return !l.bodies || l.bodies.indexOf(b) >= 0; });
  }
  function spInfo(handle) {
    var e = SI && SI.products[handle];
    // Product fields (custom.speaker_*) win over the bundled index for the current product.
    if (handle === C.product && C.productSpec) {
      var s = C.productSpec;
      return { type: s.type, size: s.size || null, depth: s.depth ? Number(s.depth) : null, vc: s.vc, ohm: s.ohm, vendor: e ? e[5] : '', marine: !!(e && e[6]), tower: !!(e && e[7]), tw: e ? e[8] || '' : '', fromProduct: true };
    }
    return e ? { type: e[0], size: e[1], depth: e[2] || null, vc: e[3], ohm: e[4], vendor: e[5], marine: !!e[6], tower: !!e[7], tw: e[8] || '' } : null;
  }
  /* 'fit' | 'size' (spot depth unknown) | 'deep' (deeper than a typical spot this size) | 'depth?' (speaker depth not listed) | 'no' */
  // 5x7" and 6x8" speakers share the same mounting opening.
  var SAME_FIT = { '5x7"': '6x8"', '6x8"': '5x7"' };
  // Speaker sizes that fit an opening with a standard mounting bracket / adapter plate.
  var ADAPTER_FIT = { '6.75"': ['6.5"'], '6x9"': ['6.5"'], '6x8"': ['6.5"'], '5x7"': ['6.5"'], '5.25"': ['5"'], '5"': ['5.25"'], '4x6"': ['4"'] };
  // Typical factory mounting depth by opening size, used only when the vehicle spot has no published depth.
  var TYPICAL_DEPTH = { '2.75"': 1.6, '3"': 1.8, '3.5"': 2.0, '4"': 2.1, '4x6"': 2.2, '5"': 2.4, '5.25"': 2.4, '5x7"': 3.0, '6x8"': 3.0, '6.5"': 3.0, '6.75"': 3.0, '6x9"': 3.6, '8"': 3.8 };
  function typicalDepth(loc) {
    var d = 0; (loc.sizes || []).forEach(function (s) { d = Math.max(d, TYPICAL_DEPTH[s] || 0); });
    return d || null;
  }
  function exactSize(loc, info) {
    return loc.kind === 'tweeter' || loc.sizes.indexOf(info.size) >= 0 || loc.sizes.indexOf(SAME_FIT[info.size]) >= 0;
  }
  // car speakers (coaxial / component) before pro-audio midrange in result lists
  function typeRank(hd) { var i = spInfo(hd); return i && i.type === 'Midrange' ? 1 : 0; }
  function needsAdapter(loc, info) {
    if (!info || exactSize(loc, info)) return false;
    return loc.sizes.some(function (s) { return (ADAPTER_FIT[s] || []).indexOf(info.size) >= 0; });
  }
  function locMatch(loc, info) {
    if (!info || loc.boxes) return 'no';
    var types = SP.locationTypes[loc.kind] || [];
    if (loc.marineOnly && !info.marine) return 'no';
    if (loc.marineOnly && loc.kind === 'soundbar' && !info.tower) return 'no';
    if (types.indexOf(info.type) < 0) return 'no';
    if (loc.kind === 'tweeter' && info.tw === 'p' && !(loc.sizes || []).some(function (s) { return parseFloat(s) >= 2.5; })) return 'no';
    if (!exactSize(loc, info) && !needsAdapter(loc, info)) return 'no';
    if (loc.depth == null) { var td = loc.kind === 'tweeter' ? null : typicalDepth(loc); return td && info.depth && info.depth > td ? 'deep' : 'size'; }
    if (!info.depth) return 'depth?';
    return info.depth <= loc.depth ? 'fit' : 'no';
  }
  function speakersFor(loc, want) {
    var out = [];
    Object.keys(SI.products).forEach(function (hd) { var m = locMatch(loc, spInfo(hd)); if (want ? m === want : (m === 'fit' || m === 'size')) out.push(hd); });
    return out;
  }
  function locUrl(v, loc) { return resultsUrl(v) + '&loc=' + encodeURIComponent(loc.id); }
  function sizeTxt(loc) { return loc.sizes && loc.sizes.length ? loc.sizes.join(' / ') : (loc.label || ''); }
  function inch(n) { return (Math.round(n * 100) / 100) + '"'; }
  function depthTxt(loc) { return loc.depth ? inch(loc.depth) + (loc.est ? '*' : '') : '<span class="eagff-nv">Standard</span>'; }
  var SHOP_CATS = {"car":[["Speakers","coaxials-components"],["Subwoofers","subwoofer"],["Amplifiers","amplifier"],["Subwoofer boxes","enclosures"],["Amp wiring kits","amp-kits"]],"moto":[["Motorcycle speakers","motorcycle-loudspeakers"],["Motorcycle amplifiers","motorcycle-amplifiers"],["Motorcycle subwoofers","motorcycle-subwoofers"]],"ps":[["Powersports amplifiers","powersports-amplifiers"],["Tower & sound bar speakers","marine-towers"],["Subwoofers","subwoofer"]],"marine":[["Marine tower speakers","marine-towers"],["Marine amplifiers","marine-amplifiers-1"],["Marine subwoofers","marine-subwoofers"]]};
  function shopTiles(v) {
    return '<div class="eagff-cats">' + (SHOP_CATS[v.type] || SHOP_CATS.car).map(function (c) {
      return '<a class="eagff-cat" href="' + esc(C.root + 'collections/' + c[1]) + '">' + esc(c[0]) + ' <span>&rarr;</span></a>';
    }).join('') + '</div>';
  }
  function noDataCard(v) {
    return '<div class="eagff-nodata"><div><strong>Get the right speakers for your ' + esc(label(v)) + '</strong>' +
      '<span>Our experts will confirm the exact speaker sizes and fit for your vehicle, free. Amplifiers, subwoofers and boxes below work with any vehicle.</span></div>' +
      '<div class="eagff-hero-btns"><a class="eagff-hbtn" href="tel:8772158187">Call (877) 215-8187</a>' +
      '<button type="button" class="eagff-hbtn eagff-hbtn--wa" data-eagff-wa>Chat on WhatsApp</button></div></div>';
  }
  /* ---------- head units: dash radio opening (eag-radio-fit.json) + head units / install parts (eag-hu-index.json) ---------- */
  var RF = null, HU = null;
  var FIT_LABEL = { '2-DIN': 'Double DIN', '1-DIN': 'Single DIN', '1-DIN or 2-DIN': 'Single or double DIN', 'kit-only': 'Factory radio (vehicle kit needed)', 'not-replaceable': 'Factory screen' };
  function radioFor(v) {
    if (!RF || !v || v.type !== 'car') return null;
    return RF.vehicles.filter(function (x) { return x.make === v.make && x.model === v.model && v.year >= x.from && v.year <= x.to; })[0] || null;
  }
  function huFor(hd) { return HU && HU.products[hd] || null; }
  function huMatches(p, v) {
    return (p.v || []).filter(function (x) { return x[0] === v.type && x[1] === v.make && x[2] === v.model && v.year >= x[3] && v.year <= x[4]; });
  }
  // universal head units that physically fit this dash (only for confirmed, unrestricted openings)
  function unitFits(p, rf) {
    if (!rf || !rf.fit || rf.restricted) return false;
    if (p.r !== 'head-unit' && p.r !== 'floating-head-unit') return false;
    var ch = p.ch || '';
    if (rf.fit === '2-DIN' || rf.fit === '1-DIN or 2-DIN') return /DIN/.test(ch);
    if (rf.fit === '1-DIN') return /^1-DIN/.test(ch);
    return false;
  }
  function huLists(v) {
    var out = { kits: [], units: [], parts: [], marine: [] }, rf = radioFor(v);
    if (!HU) return out;
    Object.keys(HU.products).forEach(function (hd) {
      var p = HU.products[hd], m = huMatches(p, v);
      if (m.length && (p.r === 'vehicle-radio-kit' || p.r === 'powersports-dash-kit' || p.r === 'motorcycle-head-unit')) out.kits.push(hd);
      else if (m.length && (p.r === 'radio-interface' || p.r === 'amp-interface' || p.r === 'speaker-harness' || p.r === 'powersports-harness')) out.parts.push(hd);
      else if (v.type === 'car' && unitFits(p, rf)) out.units.push(hd);
      else if ((v.type === 'ps' || v.type === 'marine') && p.r === 'marine-powersports-head-unit') out.marine.push(hd);
    });
    return out;
  }
  function radioNote(rf, l) {
    l = l || { kits: [], parts: [] };
    if (!rf || !rf.fit) return l.kits.length ? 'Use one of the kits made for your vehicle below, or ask our experts.' : 'Our experts will confirm which radios fit your dash.';
    if (rf.fit === 'not-replaceable') return l.parts.length ? 'The factory screen is built into the dash. Keep it and upgrade the sound with the factory-amp parts below.' : 'The factory screen is built into the dash and can\'t be swapped. Upgrade your speakers, amplifiers and subwoofers instead.';
    if (l.kits.length && (rf.restricted || rf.fit === 'kit-only')) return 'Use one of the kits made for your vehicle below. A standard radio won\'t fit this dash.';
    if (rf.restricted) return 'Only specific shallow or modular radios fit this dash. Ask our experts for the right match.';
    if (rf.fit === 'kit-only') return 'The factory radio is integrated. A vehicle-specific kit is needed. Ask our experts for the right match.';
    var n = [];
    if (rf.kit === 'required' || rf.kit === 'varies') n.push('dash kit');
    if (rf.harness) n.push('wiring harness');
    if (rf.swc) n.push('steering-wheel control interface');
    return n.length ? 'Install needs a ' + n.join(', ').replace(/, ([^,]*)$/, ' and $1') + '.' : 'Standard install.';
  }
  function radioLabel(rf) { return rf && rf.fit ? (rf.restricted ? 'Shallow / modular radios only' : FIT_LABEL[rf.fit]) : 'Ask our experts'; }
  function trimYearOk(c, y) {
    var m = String(c).match(/\b((?:19|20)\d\d)\s*(?:-|–|to)\s*((?:19|20)\d\d)\b/);
    if (m) return y >= +m[1] && y <= +m[2];
    m = String(c).match(/\b((?:19|20)\d\d)\s*\+|\b((?:19|20)\d\d)\s+and (?:later|up|newer)/i);
    if (m) return y >= +(m[1] || m[2]);
    m = String(c).match(/^((?:19|20)\d\d)\b/);
    if (m) return y === +m[1];
    return true;
  }
  function trimsHtml(rf, v) {
    var t = (rf && rf.trims || []).filter(function (x) { return x.c && x.fit !== rf.fit && (!v || trimYearOk(x.c, v.year)); });
    if (!t.length) return '';
    return '<ul class="eagff-hu-trims">' + t.slice(0, 4).map(function (x) { return '<li>' + esc(x.c) + ': <strong>' + esc(x.fit ? FIT_LABEL[x.fit] : 'ask our experts') + '</strong></li>'; }).join('') + '</ul>';
  }
  function radioRow(v) {
    var rf = radioFor(v), l = huLists(v), n = l.kits.length + l.units.length + l.parts.length;
    var btn = n ? '<a class="eagff-fbtn" href="#eagff-hu">Shop head units &amp; install (' + n + ')</a>' : '<a class="eagff-fbtn eagff-fbtn--ghost" href="tel:8772158187">Ask an expert</a>';
    return '<tr class="eagff-hu-row"><td data-l="Location"><strong>Dash radio</strong></td><td data-l="Size">' + esc(radioLabel(rf)) + '</td><td data-l="Qty">1</td><td data-l="Max depth">&mdash;</td>' +
      '<td data-l="Notes" class="eagff-fit-notes">' + esc(radioNote(rf, l)) + '</td><td class="eagff-fit-btn">' + btn + '</td></tr>';
  }
  function huSection(box, v) {
    var rf = radioFor(v), l = huLists(v);
    var all = l.kits.concat(l.units, l.parts, l.marine);
    if (!all.length && v.type !== 'car') { box.hidden = true; return; }
    box.className = 'eagff-sec eagff-hu'; box.id = 'eagff-hu';
    box.innerHTML = '<h2 class="eagff-sh">Head units for your ' + esc(label(v)) + '</h2>' +
      (v.type === 'car' ? '<div class="eagff-hu-sum"><span class="eagff-hu-fit">' + esc(radioLabel(rf)) + '</span><span>' + esc(radioNote(rf, l)) + '</span>' + trimsHtml(rf, v) + '</div>' : '') +
      '<div data-hu-kits></div><div data-hu-units></div><div data-hu-parts></div>' +
      (l.kits.length || (rf && rf.fit && !rf.restricted && rf.fit !== 'kit-only' && rf.fit !== 'not-replaceable') ? '' : '<div class="eagff-hero-btns"><a class="eagff-hbtn" href="tel:8772158187">Call (877) 215-8187</a><button type="button" class="eagff-hbtn eagff-hbtn--wa" data-eagff-wa>Chat on WhatsApp</button></div>');
    if (!all.length) return;
    fetchProducts(all, function (prods) {
      var by = {}; prods.forEach(function (p) { by[p.handle] = p; });
      function grid(el, title, list, badge) {
        var ps = list.map(function (hd) { return by[hd]; }).filter(Boolean);
        ps.sort(function (a, b) { return (b.available - a.available) || a.price - b.price; });
        if (!ps.length) return;
        el.innerHTML = '<h3 class="eagff-hu-h">' + esc(title) + '</h3><div class="eagff-grid">' + ps.map(function (p) { return cardHtml(p, badge(p), false); }).join('') + '</div>';
      }
      var vn = esc(v.year + ' ' + v.make + ' ' + v.model);
      grid(box.querySelector('[data-hu-kits]'), 'Made for your ' + label(v), l.kits, function (p) {
        var m = huMatches(huFor(p.handle), v)[0], c = m && m[5] && !/^all/i.test(m[5]) ? ' &middot; ' + esc(m[5]) : '';
        return '&#10003; Fits your ' + vn + c;
      });
      grid(box.querySelector('[data-hu-units]'), v.type === 'car' ? 'Head units that fit your dash' : 'Marine & powersports head units', v.type === 'car' ? l.units : l.marine, function (p) {
        var h = huFor(p.handle) || {};
        if (v.type !== 'car') return '&#10003; Universal fit';
        return '&#10003; Fits your dash' + (/floating/.test(h.ch || '') ? ' &middot; floating screen' : '') + (rf && (rf.kit === 'required' || rf.kit === 'varies') ? ' &middot; dash kit needed' : '');
      });
      grid(box.querySelector('[data-hu-parts]'), 'Install parts for your ' + label(v), l.parts, function (p) {
        var m = huMatches(huFor(p.handle), v)[0], c = m && m[5] && !/^all/i.test(m[5]) ? ' &middot; ' + esc(m[5]) : '';
        return '&#10003; Fits your ' + vn + c;
      });
    });
  }
  /* product page verdict for head units, radio kits and install parts (null = not a head-unit product) */
  function huVerdict(v) {
    var p = huFor(C.product);
    if (!p || !v) return null;
    var vn = label(v), m = huMatches(p, v);
    if (p.v && p.v.length) {
      if (m.length) return { cls: 'is-fit', ico: '&#10003;', title: 'Fits your ' + vn, html: (m[0][5] && !/^all/i.test(m[0][5]) ? esc(m[0][5]) + '. ' : '') + (p.ra ? esc(p.ra) + '. ' : '') + 'Questions? Call our experts at <a href="tel:8772158187">(877) 215-8187</a>.' };
      return { cls: 'is-nofit', ico: '&#10007;', title: 'Not made for your ' + vn, html: '<a href="' + esc(resultsUrl(v)) + '#eagff-hu">Shop head units &amp; install parts for your ' + esc(v.make + ' ' + v.model) + ' &rarr;</a>' };
    }
    if (p.r === 'marine-powersports-head-unit') return v.type === 'car' ? null : { cls: 'is-fit', ico: '&#10003;', title: 'Works with your ' + vn, html: 'Universal marine & powersports head unit.' };
    if (p.r !== 'head-unit' && p.r !== 'floating-head-unit' || v.type !== 'car') return null;
    var rf = radioFor(v);
    if (unitFits(p, rf)) return { cls: 'is-fit', ico: '&#10003;', title: 'Fits your ' + vn + ' dash (' + FIT_LABEL[rf.fit].toLowerCase() + ')', html: esc(radioNote(rf)) + (/floating/.test(p.ch || '') ? ' Floating screen: check it clears your vents and controls.' : '') + ' Questions? Call <a href="tel:8772158187">(877) 215-8187</a>.' };
    if (!rf || !rf.fit) return { cls: 'is-universal', ico: 'i', title: 'Let us confirm the fit for your ' + vn, html: 'Our experts will check this radio for your dash: <a href="tel:8772158187">(877) 215-8187</a> or <button type="button" class="eagff-pbox-wa" data-eagff-wa>chat on WhatsApp</button>.' };
    if (rf.fit === 'not-replaceable') return { cls: 'is-nofit', ico: '&#10007;', title: 'Your ' + vn + ' has a built-in factory screen', html: '<a href="' + esc(resultsUrl(v)) + '#eagff-hu">See sound upgrades that keep your factory screen &rarr;</a>' };
    return { cls: 'is-warn', ico: 'i', title: 'Your ' + vn + ' needs a vehicle-specific kit', html: esc(radioNote(rf)) + ' <a href="' + esc(resultsUrl(v)) + '#eagff-hu">See what fits your ' + esc(v.make + ' ' + v.model) + ' &rarr;</a>' };
  }
  function fitTable(v, sv) {
    var b = spBody(sv, v), made = handlesFor(v).length;
    var rows = spLocations(sv, v).map(function (l) {
      var btn = l.boxes
        ? (made ? '<a class="eagff-fbtn" href="#eagff-made">Shop boxes (' + made + ')</a>' : '<a class="eagff-fbtn eagff-fbtn--ghost" href="tel:8772158187">Ask an expert</a>')
        : (speakersFor(l).length ? '<a class="eagff-fbtn" href="' + esc(locUrl(v, l)) + '">Shop speakers that fit (' + speakersFor(l).length + ')</a>' : '<a class="eagff-fbtn eagff-fbtn--ghost" href="tel:8772158187">Ask an expert</a>');
      return '<tr><td data-l="Location"><strong>' + esc(l.name) + '</strong></td>' +
        '<td data-l="Size">' + (l.boxes ? 'Vehicle-specific boxes' : esc(l.label || sizeTxt(l))) + '</td>' +
        '<td data-l="Qty">' + (l.qty || '&mdash;') + '</td>' +
        '<td data-l="Max depth">' + (l.boxes ? '&mdash;' : depthTxt(l)) + '</td>' +
        '<td data-l="Notes" class="eagff-fit-notes">' + esc(l.notes || '') + '</td><td class="eagff-fit-btn">' + btn + '</td></tr>';
    }).join('');
    return '<div class="eagff-sec eagff-fitsec"><h2 class="eagff-sh">What fits your ' + esc(label(v)) + '</h2>' +
      (b ? '' : '<p class="eagff-fit-note">Showing <strong>' + esc(sv.bodies[0]) + '</strong>. <button type="button" data-eagff-open>Pick your trim / body</button> for an exact fit.</p>') +
      '<div class="eagff-fit-wrap"><table class="eagff-fit-t"><thead><tr><th>Location</th><th>Size</th><th>Qty</th><th>Max depth</th><th>Notes</th><th></th></tr></thead>' +
      '<tbody>' + rows + (v.type === 'car' ? radioRow(v) : '') + '</tbody></table></div>' +
      '<p class="eagff-fit-foot">* Depth from installer and adapter specs. Standard = factory opening; most speakers of this size fit. Need help? Call (877) 215-8187.</p></div>';
  }
  function locationMode(head, card, out, v, sv, loc) {
    card.hidden = true;
    var fitList = speakersFor(loc), unk = speakersFor(loc, 'depth?').concat(speakersFor(loc, 'deep'));
    head.innerHTML = '<p class="eagff-rk">' + ICONS[v.type] + ' Speakers that fit</p><h1 class="eagff-rh">' + esc(loc.name) + '</h1>' +
      '<p class="eagff-rs">' + esc(label(v)) + ' &middot; ' + esc(sizeTxt(loc)) + (loc.depth ? ' &middot; max mounting depth ' + depthTxt(loc) : ' &middot; standard depth') + ' &middot; ' + (loc.qty || '') + ' needed</p>' +
      '<div class="eagff-hero-btns"><a class="eagff-hbtn" href="' + esc(resultsUrl(v)) + '">&larr; All locations</a>' +
      '<button type="button" class="eagff-hbtn eagff-hbtn--ghost" data-eagff-open>Change vehicle</button></div>';
    if (!fitList.length && !unk.length) {
      out.innerHTML = '<div class="eagff-none"><h2>No speakers listed for this spot yet</h2></div>' + noDataCard(v);
      return;
    }
    skeleton(out, fitList.length || 4);
    fetchProducts(fitList.concat(unk), function (prods) { drawSpeakers(out, prods, loc, fitList); });
  }
  function drawSpeakers(out, prods, loc, fitList) {
    var st = { brand: '', type: '', stock: false, sort: 'stock', unknown: false };
    var isFit = function (p) { return fitList.indexOf(p.handle) >= 0; };
    var nUnk = prods.filter(function (p) { return !isFit(p); }).length;
    var brands = {}, types = {};
    prods.forEach(function (p) { brands[p.vendor] = 1; var i = spInfo(p.handle); if (i) types[i.type] = 1; });
    out.innerHTML = '';
    var bar = h('div', { class: 'eagff-toolbar eagff-toolbar--sp' });
    bar.innerHTML =
      '<div class="eagff-chips" data-types></div>' +
      '<div class="eagff-tools">' +
      '<label class="eagff-sort">Brand <select data-brand><option value="">All brands</option>' + Object.keys(brands).sort().map(function (b) { return '<option>' + esc(b) + '</option>'; }).join('') + '</select></label>' +
      '<label class="eagff-sort">Sort <select data-sort><option value="stock">In stock first</option><option value="low">Price: low to high</option><option value="high">Price: high to low</option></select></label>' +
      '<label class="eagff-stock"><input type="checkbox" data-stock> In stock only</label>' +
      (nUnk ? '<label class="eagff-stock"><input type="checkbox" data-unk> + ' + nUnk + ' deeper speakers (custom mounting)</label>' : '') + '</div>';
    var grid = h('div', { class: 'eagff-grid' });
    out.appendChild(bar); out.appendChild(grid);
    function paintTypes() {
      var box = bar.querySelector('[data-types]'); box.innerHTML = '';
      var ks = Object.keys(types).sort(); if (ks.length < 2) return;
      [''].concat(ks).forEach(function (t) {
        box.appendChild(h('button', { type: 'button', class: 'eagff-chip' + (st.type === t ? ' is-on' : ''), onclick: function () { st.type = t; paint(); } }, [t || 'All types']));
      });
    }
    function paint() {
      paintTypes();
      var filtered = !!(st.brand || st.type); /* brief: any filter selected hides sold-out items */
      var list = prods.filter(function (p) {
        var i = spInfo(p.handle) || {};
        if (!isFit(p) && !st.unknown) return false;
        if (st.brand && p.vendor !== st.brand) return false;
        if (st.type && i.type !== st.type) return false;
        if ((st.stock || filtered) && !p.available) return false;
        return true;
      });
      list.sort(function (a, b) {
        // sold-out always last, whatever the sort
        if (b.available !== a.available) return b.available - a.available;
        if (st.sort === 'low') return a.price - b.price;
        if (st.sort === 'high') return b.price - a.price;
        return (b.available - a.available) || (isFit(b) - isFit(a)) || (needsAdapter(loc, spInfo(a.handle)) - needsAdapter(loc, spInfo(b.handle))) || (typeRank(a.handle) - typeRank(b.handle)) || a.price - b.price;
      });
      grid.innerHTML = list.length ? list.map(function (p) {
        var i = spInfo(p.handle) || {};
        var badge = !isFit(p) ? 'Right size' + (i.depth ? ' &middot; ' + inch(i.depth) + ' deep' : '')
          : loc.depth == null ? '&#10003; Size fits' + (i.depth ? ' &middot; ' + inch(i.depth) + ' deep' : '')
          : '&#10003; Fits ' + esc(loc.name.toLowerCase()) + ' &middot; ' + inch(i.depth) + ' deep';
        if (needsAdapter(loc, i)) badge = '&#10003; Fits with adapter' + (i.depth ? ' &middot; ' + inch(i.depth) + ' deep' : '');
        return cardHtml(p, badge, false);
      }).join('') : '<p class="eagff-empty-grid">No speakers match these filters.</p>';
    }
    bar.querySelector('[data-brand]').addEventListener('change', function (e) { st.brand = e.target.value; paint(); });
    bar.querySelector('[data-sort]').addEventListener('change', function (e) { st.sort = e.target.value; paint(); });
    bar.querySelector('[data-stock]').addEventListener('change', function (e) { st.stock = e.target.checked; paint(); });
    var u = bar.querySelector('[data-unk]'); if (u) u.addEventListener('change', function (e) { st.unknown = e.target.checked; paint(); });
    paint();
  }
  function cardHtml(p, badge, warn) {
    var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
    var off = p.compare_at_price > p.price ? Math.round((1 - p.price / p.compare_at_price) * 100) : 0;
    return '<a class="eagff-card" href="' + esc(C.root + 'products/' + p.handle) + '">' +
      '<span class="eagff-card-img">' + (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '') +
      (off ? '<span class="eagff-card-off">-' + off + '%</span>' : '') + (p.available ? '' : '<span class="eagff-card-so">Sold out</span>') + '</span>' +
      '<span class="eagff-fit' + (warn ? ' eagff-fit--warn' : '') + '">' + badge + '</span>' +
      '<span class="eagff-card-v">' + esc(p.vendor) + '</span><span class="eagff-card-t">' + esc(p.title) + '</span>' +
      '<span class="eagff-card-p">' + money(p.price) + (off ? ' <s>' + money(p.compare_at_price) + '</s>' : '') + '</span>' +
      '<span class="eagff-card-cta">View product</span></a>';
  }
  /* product page: speaker verdict for the saved vehicle (null = not a speaker) */
  function speakerVerdict(v) {
    var info = spInfo(C.product);
    if (!info || !v) return null;
    var sv = spFor(v);
    if (!sv) return { cls: 'is-universal', ico: 'i', title: 'Let us confirm the fit for your ' + label(v), html: 'Our experts will check this speaker for your vehicle: <a href="tel:8772158187">(877) 215-8187</a> or <button type="button" class="eagff-pbox-wa" data-eagff-wa>chat on WhatsApp</button>.' };
    if (info.type === 'Subwoofer') return { cls: 'is-universal', ico: 'i', title: 'Subwoofers mount in an enclosure', html: '<a href="' + esc(resultsUrl(v)) + '#eagff-made">Shop sub boxes made for your ' + esc(v.make + ' ' + v.model) + ' &rarr;</a>' };
    var fitL = [], depL = [], sizeL = [], deepL = [], adapt = false, exact = false;
    spLocations(sv, v).forEach(function (l) {
      var m = locMatch(l, info);
      if (m !== 'no') { if (needsAdapter(l, info)) adapt = true; else exact = true; }
      if (m === 'fit') fitL.push(l.name.toLowerCase()); else if (m === 'depth?') depL.push(l.name.toLowerCase()); else if (m === 'size') sizeL.push(l.name.toLowerCase()); else if (m === 'deep') deepL.push(l.name.toLowerCase());
    });
    if (fitL.length) return { cls: 'is-fit', ico: '&#10003;', title: 'Fits your ' + label(v) + ' (' + fitL.join(' + ') + ')', html: (esc(info.size) + ' &middot; mounting depth ' + inch(info.depth) + '. Fit based on size and depth; adapters may be needed.') + (adapt && !exact ? ' Installs with a standard mounting adapter (sold separately).' : '') };
    if (sizeL.length) return { cls: 'is-fit', ico: '&#10003;', title: 'Fits your ' + label(v) + ' (' + sizeL.join(' + ') + ')', html: ('Right size for these factory locations' + (info.depth ? ' &middot; mounting depth ' + inch(info.depth) : '') + '. Need help with the install? Call our experts at <a href="tel:8772158187">(877) 215-8187</a>.') + (adapt && !exact ? ' Installs with a standard mounting adapter (sold separately).' : '') };
    if (depL.length) return { cls: 'is-fit', ico: '&#10003;', title: 'Fits your ' + label(v) + ' (' + depL.join(' + ') + ')', html: ('Right size for these factory locations. Need help with the install? Call our experts at <a href="tel:8772158187">(877) 215-8187</a>.') + (adapt && !exact ? ' Installs with a standard mounting adapter (sold separately).' : '') };
    if (deepL.length) return { cls: 'is-warn', ico: 'i', title: 'Right size for your ' + label(v) + ' (' + deepL.join(' + ') + ')', html: 'This speaker is ' + inch(info.depth) + ' deep, deeper than most factory spots this size, so it may need a custom mount or spacer. Our experts can recommend the best fit: <a href="tel:8772158187">(877) 215-8187</a>.' };
    return { cls: 'is-nofit', ico: '&#10007;', title: 'Not the right size for your ' + label(v), html: '<a href="' + esc(resultsUrl(v)) + '">Shop speakers that fit your ' + esc(v.make + ' ' + v.model) + ' &rarr;</a>' };
  }
  /* collection pages for speakers / subs: selector at the top */
  var cbar = null;
  function collectionFinder() {
    if (!C.speakerCollection || active()) { if (cbar) { cbar.remove(); cbar = null; } return; }
    if (cbar) return;
    var main = document.getElementById('MainContent'); if (!main) return;
    cbar = h('div', { class: 'eagff-cbar' });
    cbar.innerHTML = '<div class="container eagff-cbar-in"><div class="eagff-cbar-t"><strong>What fits my vehicle?</strong><span>Pick your vehicle to see the speaker sizes that fit.</span></div>' +
      '<div class="eagff-picker eagff-picker--row" data-p></div></div>';
    main.insertBefore(cbar, main.firstChild);
    new Picker(cbar.querySelector('[data-p]'), { goText: 'Show what fits', onDone: function (nv) { location.href = resultsUrl(nv); } });
  }

  /* ---------- header CTA / mobile strip ---------- */
  function refresh() {
    var v = active();
    document.querySelectorAll('[data-eagff-cta]').forEach(function (el) {
      var top = el.querySelector('[data-eagff-cta-top]'), main = el.querySelector('[data-eagff-cta-main]');
      el.classList.toggle('has-vehicle', !!v);
      if (top) top.textContent = v ? 'Your vehicle' : 'Find parts that fit';
      if (main) main.textContent = v ? label(v) : 'Set your vehicle';
      el.title = v ? label(v) + ' (click to change)' : 'Set your vehicle';
      /* icon follows the vehicle type (car / motorcycle / powersports / marine) */
      var t = (v && v.type && ICONS[v.type]) ? v.type : 'car', svg = el.querySelector('svg');
      if (svg && svg.getAttribute('data-eagff-ico') !== t && (t !== 'car' || svg.hasAttribute('data-eagff-ico'))) {
        var tmp = document.createElement('span'); tmp.innerHTML = ICONS[t];
        var ns = tmp.firstChild;
        ns.setAttribute('width', svg.getAttribute('width') || '20'); ns.setAttribute('height', svg.getAttribute('height') || '20');
        ns.setAttribute('data-eagff-ico', t);
        svg.parentNode.replaceChild(ns, svg);
      }
    });
    if (D) { productBox(); collectionBanner(); collectionFinder(); }
  }

  /* ---------- product page fitment card (every product) ---------- */
  var pbox = null;
  function fitLines(handle) {
    return (D.products[handle] || []).map(function (f) {
      return f[1] + ' ' + f[2] + ' &middot; ' + f[3] + '&ndash;' + (f[4] >= D.maxYear ? 'Up' : f[4]) + (f[5] && f[5].length ? ' &middot; ' + esc(f[5].join(', ')) : '');
    });
  }
  function productBox() {
    if (!C.product) return;
    var v = active(), state = fits(C.product, v);
    if (!pbox) {
      var form = document.querySelector('#MainContent product-form') || document.querySelector('product-form');
      if (!form) return;
      pbox = h('div', { class: 'eagff-pbox' });
      form.parentNode.insertBefore(pbox, form);
    }
    var hv = huVerdict(v), mapped = !hv && state !== null, sp = hv || (mapped ? null : speakerVerdict(v));
    var cls = !v ? 'is-none' : sp ? sp.cls : state === true ? 'is-fit' : state === false ? 'is-nofit' : C.productUniversal ? 'is-universal' : 'is-check';
    var head = '<div class="eagff-pbox-head"><span class="eagff-pbox-k">' + ICONS[(v && v.type) || 'car'] + ' Vehicle fitment</span>' +
      (v ? '<button type="button" class="eagff-pbox-link" data-eagff-open="check">Change vehicle</button>' : '') + '</div>';
    var body;
    if (!v) {
      body = '<div class="eagff-pbox-body"><div class="eagff-pbox-msg"><strong>Discover more. Set your vehicle.</strong>' +
        '<span>' + (mapped ? 'This part is made for specific vehicles. Set yours to confirm it fits.' : 'See instantly what fits, plus parts made for your vehicle.') + '</span></div>' +
        '<button type="button" class="eagff-pbox-btn" data-eagff-open="check">Check if this fits your vehicle</button></div>';
    } else if (sp) {
      body = '<div class="eagff-pbox-body"><span class="eagff-pbox-ico">' + sp.ico + '</span><div class="eagff-pbox-msg"><strong>' + esc(sp.title) + '</strong><span>' + sp.html + '</span></div></div>';
    } else if (state === true) {
      body = '<div class="eagff-pbox-body"><span class="eagff-pbox-ico">&#10003;</span><div class="eagff-pbox-msg"><strong>Fits your ' + esc(label(v)) + '</strong>' +
        '<span>Confirmed fitment for your vehicle.</span></div></div>';
    } else if (state === false) {
      body = '<div class="eagff-pbox-body"><span class="eagff-pbox-ico">&#10007;</span><div class="eagff-pbox-msg"><strong>Does not fit your ' + esc(label(v)) + '</strong>' +
        '<span><a href="' + esc(resultsUrl(v)) + '">Shop parts that fit your ' + esc(v.make + ' ' + v.model) + ' &rarr;</a></span></div></div>';
    } else if (!C.productUniversal) {
      // No fitment data and not a universal part: never claim it fits; send them to an expert instead.
      body = '<div class="eagff-pbox-body"><span class="eagff-pbox-ico">?</span><div class="eagff-pbox-msg"><strong>Check fitment with our experts</strong>' +
        '<span>We have not confirmed this part for your ' + esc(label(v)) + ' yet. Call <a href="tel:8772158187">(877) 215-8187</a> or ' +
        '<a href="https://wa.me/15624451622?text=' + encodeURIComponent('Hi, does this fit my ' + label(v) + '? ' + location.href) + '" target="_blank" rel="noopener">message us on WhatsApp</a> before you order.</span>' +
        '<span><a href="' + esc(resultsUrl(v)) + '">Shop parts made for your ' + esc(label(v)) + ' &rarr;</a></span></div></div>';
    } else {
      body = '<div class="eagff-pbox-body"><span class="eagff-pbox-ico">i</span><div class="eagff-pbox-msg"><strong>Works with your ' + esc(label(v)) + '</strong>' +
        '<span>Universal fit, not tied to one vehicle. Questions? Call our experts at <a href="tel:8772158187">(877) 215-8187</a>.</span>' +
        '<span><a href="' + esc(resultsUrl(v)) + '">Shop parts made for your ' + esc(label(v)) + ' &rarr;</a></span></div></div>';
    }
    var list = '';
    if (mapped) {
      var lines = fitLines(C.product);
      list = '<details class="eagff-pbox-list"><summary>See vehicles this fits (' + lines.length + ')</summary><ul><li>' + lines.join('</li><li>') + '</li></ul></details>';
    }
    pbox.className = 'eagff-pbox ' + cls;
    pbox.innerHTML = head + body + list;
  }
  /* "Whoa! Slow down." vehicle prompt before add to cart: switched OFF 2026-10-17 at the client's
     request (shoppers must never have to enter a vehicle to buy). The product page fit box still
     shows which vehicles a product fits. To bring it back, restore the document submit listener
     from the backup copy in Eliteautogear/sticky-atc-fix-2026-10-17/live-before/assets/eag-ff.js. */
  function ignoredKey() { return 'eagff_ignore_' + C.product; }
  function resumeAtc() {
    if (!pending) return;
    var p = pending; p.resumed = true;
    setTimeout(function () {
      try { p.form.requestSubmit ? p.form.requestSubmit(p.submitter || undefined) : p.form.submit(); } catch (x) { p.form.requestSubmit(); }
      pending = null;
    }, 50);
  }

  /* ---------- collection / search banner ---------- */
  var banner = null;
  function collectionBanner() {
    if (!C.listing) return;
    var v = active();
    var main = document.getElementById('MainContent');
    if (!main) return;
    if (!v) { if (banner) banner.remove(); banner = null; return; }
    var n = handlesFor(v).length;
    if (!banner) { banner = h('div', { class: 'eagff-banner' }); main.insertBefore(banner, main.firstChild); }
    banner.innerHTML = '<span class="eagff-banner-ico">' + ICONS[v.type] + '</span><div class="eagff-banner-txt">Shopping for <strong>' +
      esc(label(v)) + '</strong>' +
      '</div>' + (n ? '<a class="eagff-banner-go" href="' + esc(resultsUrl(v)) + '">' + (spFor(v) ? 'See what fits your vehicle' : 'View products that fit') + '</a>' : '') +
      '<button type="button" class="eagff-banner-link" data-eagff-open>Change</button>';
  }

  /* ---------- results / "Select your vehicle" page ---------- */
  function fetchProducts(list, done) {
    var prods = [], i = 0;
    function worker() {
      if (i >= list.length) return Promise.resolve();
      var hd = list[i++];
      return fetch(C.root + 'products/' + hd + '.js').then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (p) { if (p) prods.push(p); return worker(); });
    }
    var ws = []; for (var w = 0; w < 6; w++) ws.push(worker());
    Promise.all(ws).then(function () { done(prods); });
  }
  /* ---------- "Shop for your vehicle": parts that work with any vehicle (amps, subs, wiring) ---------- */
  var UNIV = {"car":[["Amplifiers","amplifier","eag_ch_"],["Subwoofers","subwoofer","eag_size_"],["Amp wiring kits","amp-kits",""]],"moto":[["Amplifiers","motorcycle-amplifiers","eag_ch_"],["Speakers","motorcycle-loudspeakers","eag_size_"],["Subwoofers","motorcycle-subwoofers","eag_size_"]],"ps":[["Amplifiers","powersports-amplifiers","eag_ch_"],["Sound bars & tower speakers","marine-towers",""],["Subwoofers","subwoofer","eag_size_"]],"marine":[["Amplifiers","marine-amplifiers-1","eag_ch_"],["Tower speakers","marine-towers",""],["Subwoofers","marine-subwoofers","eag_size_"]]};
  var UNIV_SHOW = 12, collCache = {};
  function collProducts(handle, done) {
    if (collCache[handle]) { done(collCache[handle]); return; }
    var all = [];
    (function page(n) {
      fetch(C.root + 'collections/' + handle + '/products.json?limit=250&page=' + n).then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; })
        .then(function (d) {
          (d.products || []).forEach(function (p) {
            var vs = p.variants || [], v0 = vs[0] || {};
            all.push({ handle: p.handle, title: p.title, vendor: p.vendor, tags: p.tags || [],
              available: vs.some(function (x) { return x.available; }),
              price: Math.round(parseFloat(v0.price || 0) * 100), compare_at_price: Math.round(parseFloat(v0.compare_at_price || 0) * 100),
              featured_image: p.images && p.images[0] ? p.images[0].src : '' });
          });
          if ((d.products || []).length === 250 && n < 4) page(n + 1); else { collCache[handle] = all; done(all); }
        });
    })(1);
  }
  function chipLabel(prefix, tag) {
    var v = tag.slice(prefix.length);
    if (prefix === 'eag_ch_') return v === '1' ? 'Mono' : v + '-channel';
    return v.replace('-', '.') + '"';
  }
  function universalSection(box, v) {
    var tabs = UNIV[v.type] || UNIV.car, cur = 0, chip = '', shown = UNIV_SHOW;
    box.className = 'eagff-sec eagff-univ';
    box.innerHTML = '<h2 class="eagff-sh">Shop for your ' + esc(label(v)) + '</h2>' +
      '<p class="eagff-univ-sub">Universal parts that work with your vehicle.</p>' +
      '<div class="eagff-vtabs">' + tabs.map(function (t, i) { return '<button type="button" class="eagff-vtab" data-u="' + i + '">' + esc(t[0]) + '</button>'; }).join('') + '</div>' +
      '<div class="eagff-chips" data-uchips></div><div data-ugrid></div><div class="eagff-univ-more" data-umore></div>';
    var grid = box.querySelector('[data-ugrid]'), chips = box.querySelector('[data-uchips]'), more = box.querySelector('[data-umore]');
    function draw() {
      var t = tabs[cur];
      box.querySelectorAll('.eagff-vtab').forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-u') === cur); });
      skeleton(grid, 8); chips.innerHTML = ''; more.innerHTML = '';
      collProducts(t[1], function (prods) {
        if (tabs[cur] !== t) return;
        // filter chips from the collection's own tags (channels for amps, size for subs)
        var cs = {};
        if (t[2]) prods.forEach(function (p) { p.tags.forEach(function (g) { if (g.indexOf(t[2]) === 0) cs[g] = (cs[g] || 0) + 1; }); });
        var keys = Object.keys(cs).sort(function (a, b) { return parseFloat(a.slice(t[2].length)) - parseFloat(b.slice(t[2].length)); });
        if (keys.length > 1) {
          chips.innerHTML = ['<button type="button" class="eagff-chip' + (chip ? '' : ' is-on') + '" data-c="">All (' + prods.length + ')</button>'].concat(keys.map(function (k) {
            return '<button type="button" class="eagff-chip' + (chip === k ? ' is-on' : '') + '" data-c="' + esc(k) + '">' + esc(chipLabel(t[2], k)) + ' (' + cs[k] + ')</button>';
          })).join('');
        }
        var list = prods.filter(function (p) { return !chip || p.tags.indexOf(chip) >= 0; });
        list = list.filter(function (p) { return p.available; }).concat(list.filter(function (p) { return !p.available; }));
        grid.innerHTML = list.length ? '<div class="eagff-grid">' + list.slice(0, shown).map(function (p) {
          return cardHtml(p, '&#10003; Works with your ' + esc(v.year + ' ' + v.make + ' ' + v.model), false);
        }).join('') + '</div>' : '<p class="eagff-univ-sub">No products in this group right now.</p>';
        more.innerHTML = (list.length > shown ? '<button type="button" class="eagff-hbtn" data-umorebtn>Show more (' + (list.length - shown) + ')</button> ' : '') +
          '<a class="eagff-hbtn eagff-hbtn--ghost" href="' + esc(C.root + 'collections/' + t[1]) + '">View all ' + esc(t[0].toLowerCase()) + ' &rarr;</a>';
      });
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-u]'); if (b) { cur = +b.getAttribute('data-u'); chip = ''; shown = UNIV_SHOW; draw(); return; }
      var c = e.target.closest('[data-c]'); if (c) { chip = c.getAttribute('data-c'); shown = UNIV_SHOW; draw(); return; }
      if (e.target.closest('[data-umorebtn]')) { shown += 24; draw(); }
    });
    draw();
  }

  function skeleton(out, n) {
    out.innerHTML = '<div class="eagff-grid">' + new Array(Math.min(n, 8) + 1).join('<div class="eagff-card eagff-skel"></div>') + '</div>';
  }
  function results(root) {
    var q = new URLSearchParams(location.search);
    if (q.get('y') && q.get('mk') && q.get('md')) {
      var fromUrl = { type: q.get('t') || 'car', year: Number(q.get('y')), make: q.get('mk'), model: q.get('md') };
      if (q.get('cab')) fromUrl.cab = q.get('cab');
      if (D.vehicles[fromUrl.type + '|' + fromUrl.make + '|' + fromUrl.model] || spFor(fromUrl) || knownVehicle(fromUrl)) setActive(fromUrl);
    }
    var modelKey = !q.get('y') && q.get('mk') && q.get('md') ? (q.get('t') || 'car') + '|' + q.get('mk') + '|' + q.get('md') : null;
    if (modelKey && !D.vehicles[modelKey]) modelKey = null;
    var v = modelKey ? null : active();
    var head = root.querySelector('[data-eagff-results-head]');
    var card = root.querySelector('[data-eagff-hero-card]');
    var out = root.querySelector('[data-eagff-results-list]');
    var picker = new Picker(root.querySelector('[data-eagff-results-finder]'), { goText: 'Find products', onDone: function (nv) { location.href = resultsUrl(nv); } });
    root.classList.toggle('has-vehicle', !!v);

    if (v) { vehicleMode(root, head, card, out, v); return; }
    if (modelKey) { modelMode(head, out, modelKey, picker); return; }
    landing(out, picker, card);
  }

  function vehicleMode(root, head, card, out, v) {
    card.hidden = true;
    var sv = spFor(v), locId = new URLSearchParams(location.search).get('loc');
    if (sv && locId) {
      var loc = spLocations(sv, v).filter(function (l) { return l.id === locId; })[0];
      if (loc && !loc.boxes) { locationMode(head, card, out, v, sv, loc); return; }
    }
    var list = handlesFor(v);
    head.innerHTML = '<p class="eagff-rk">' + ICONS[v.type] + ' Shop your vehicle</p><h1 class="eagff-rh">' + esc(label(v)) + '</h1>' +
      '<p class="eagff-rs" data-eagff-count>' + (list.length ? 'Loading parts that fit&hellip;' : '') + '</p>' +
      '<div class="eagff-hero-btns"><button type="button" class="eagff-hbtn" data-eagff-open>Change vehicle</button>' +
      '<a class="eagff-hbtn eagff-hbtn--ghost" href="' + esc(C.results) + '" data-eagff-shopwithout>Shop without vehicle</a></div>' + garageChips(v);
    out.innerHTML = (sv ? fitTable(v, sv) + '<div data-eagff-spk></div>' : noDataCard(v)) + '<div data-eagff-hu></div>' +
      '<div class="eagff-sec" id="eagff-made"><h2 class="eagff-sh">Made for your vehicle</h2><div data-eagff-made></div></div>' +
      '<div data-eagff-univ></div>';
    if (!list.length) out.insertBefore(out.querySelector('[data-eagff-univ]'), out.querySelector('#eagff-made'));
    universalSection(out.querySelector('[data-eagff-univ]'), v);
    huSection(out.querySelector('[data-eagff-hu]'), v);
    if (location.hash === '#eagff-hu') setTimeout(function () { var x = document.getElementById('eagff-hu'); if (x) x.scrollIntoView(); }, 600);
    if (sv) speakerPreview(out.querySelector('[data-eagff-spk]'), v, sv);
    var made = out.querySelector('[data-eagff-made]'), cnt = head.querySelector('[data-eagff-count]');
    if (sv) cnt.textContent = 'Speaker sizes for every location, plus parts made for your vehicle.';
    if (!list.length) { if (!sv) cnt.textContent = ''; made.parentNode.hidden = true; return; }
    skeleton(made, list.length);
    fetchProducts(list, function (prods) {
      if (!prods.length) { made.parentNode.hidden = true; return; }
      if (!sv) cnt.textContent = prods.length + ' part' + (prods.length === 1 ? '' : 's') + ' made to fit your vehicle';
      drawResults(made, prods, function () { return '&#10003; Fits your ' + esc(v.year + ' ' + v.make + ' ' + v.model); });
      if (location.hash === '#eagff-made') made.parentNode.scrollIntoView();
    });
  }
  /* vehicle page: a few speakers per location, so fitting speakers show without opening each location */
  var SPK_SHOW = 8, SPK_FETCH = 16;
  function speakerPreview(box, v, sv) {
    var locs = spLocations(sv, v).filter(function (l) { return !l.boxes && speakersFor(l).length; });
    if (!locs.length) return;
    box.className = 'eagff-sec eagff-spk';
    box.innerHTML = '<h2 class="eagff-sh">Speakers that fit your ' + esc(label(v)) + '</h2>' +
      '<div class="eagff-vtabs">' + locs.map(function (l, i) {
        return '<button type="button" class="eagff-vtab' + (i ? '' : ' is-on') + '" data-i="' + i + '">' + esc(l.name) + ' &middot; ' + esc(l.label || sizeTxt(l)) + '</button>';
      }).join('') + '</div><div data-eagff-spk-grid></div><div class="eagff-spk-more" data-eagff-spk-more></div>';
    var grid = box.querySelector('[data-eagff-spk-grid]'), more = box.querySelector('[data-eagff-spk-more]'), cache = {};
    function show(i) {
      var l = locs[i], fit = speakersFor(l);
      box.querySelectorAll('.eagff-vtab').forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-i') === i); });
      more.innerHTML = '<a class="eagff-fbtn" href="' + esc(locUrl(v, l)) + '">See all ' + fit.length + ' speakers for ' + esc(l.name.toLowerCase()) + ' &rarr;</a>';
      function paint(prods) {
        if (cache.cur !== i) return;
        var list = prods.slice().sort(function (a, b) { return (b.available - a.available) || (needsAdapter(l, spInfo(a.handle)) - needsAdapter(l, spInfo(b.handle))) || (typeRank(a.handle) - typeRank(b.handle)) || a.price - b.price; }).slice(0, SPK_SHOW);
        grid.innerHTML = '<div class="eagff-grid">' + list.map(function (p) {
          var inf = spInfo(p.handle) || {};
          var badge = l.depth == null ? '&#10003; Size fits' + (inf.depth ? ' &middot; ' + inch(inf.depth) + ' deep' : '') : '&#10003; Fits ' + esc(l.name.toLowerCase()) + ' &middot; ' + inch(inf.depth) + ' deep';
          if (needsAdapter(l, inf)) badge = '&#10003; Fits with adapter' + (inf.depth ? ' &middot; ' + inch(inf.depth) + ' deep' : '');
          return cardHtml(p, badge, l.depth == null);
        }).join('') + '</div>';
      }
      cache.cur = i;
      if (cache[i]) { paint(cache[i]); return; }
      skeleton(grid, SPK_SHOW);
      // prefer speakers with a listed depth, then the rest
      var withDepth = fit.filter(function (hd) { return (spInfo(hd) || {}).depth; });
      var pick = withDepth.concat(fit.filter(function (hd) { return withDepth.indexOf(hd) < 0; })).slice(0, SPK_FETCH);
      fetchProducts(pick, function (prods) { cache[i] = prods; paint(prods); });
    }
    box.querySelectorAll('.eagff-vtab').forEach(function (b) { b.addEventListener('click', function () { show(+b.getAttribute('data-i')); }); });
    show(0);
  }
  function garageChips(v) {
    var g = garage(), others = g.list.filter(function (x) { return vid(x) !== vid(v); });
    if (!others.length) return '';
    var extra = others.length - GARAGE_SHOW;
    return '<div class="eagff-gchips"><span>Your garage:</span>' + others.map(function (x, i) {
      return '<a href="' + esc(resultsUrl(x)) + '"' + (i >= GARAGE_SHOW ? ' class="eagff-gchip-x"' : '') + '>' + esc(label(x)) + '</a>';
    }).join('') + (extra > 0 ? '<button type="button" class="eagff-gchips-more" data-eagff-gmore data-n="' + extra + '">Show more (' + extra + ')</button>' : '') + '</div>';
  }

  function modelMode(head, out, key, picker) {
    var p = key.split('|'), links = D.vehicles[key], from = 9999, to = 0, by = {};
    links.forEach(function (l) {
      from = Math.min(from, l[1]); to = Math.max(to, l[2]);
      var t = l[1] + '&ndash;' + (l[2] >= D.maxYear ? 'Up' : l[2]) + (l[3] && l[3].length ? ' ' + esc(l[3].join(' / ')) : '');
      by[l[0]] = by[l[0]] ? by[l[0]] + '; ' + t : t;
    });
    picker.type = p[0]; picker.build();
    head.innerHTML = '<p class="eagff-rk">' + ICONS[p[0]] + ' Shop by vehicle</p><h1 class="eagff-rh">' + esc(p[1] + ' ' + p[2]) + ' parts</h1>' +
      '<p class="eagff-rs" data-eagff-count>Pick your year on the right to confirm exact fitment.</p>' +
      '<div class="eagff-hero-btns"><a class="eagff-hbtn eagff-hbtn--ghost" href="' + esc(C.results) + '">All vehicles</a></div>';
    var list = Object.keys(by);
    skeleton(out, list.length);
    fetchProducts(list, function (prods) {
      if (!prods.length) { out.innerHTML = ''; return; }
      head.querySelector('[data-eagff-count]').textContent = prods.length + ' parts for ' + p[1] + ' ' + p[2] + ' (' + from + '–' + (to >= D.maxYear ? 'Up' : to) + '). Pick your year to confirm exact fitment.';
      drawResults(out, prods, function (pr) { return 'Fits ' + p[2] + ' ' + by[pr.handle]; });
    });
  }

  function landing(out, picker, card) {
    var counts = {}, fam = [];
    Object.keys(D.vehicles).forEach(function (k) {
      var t = k.split('|')[0], hs = {};
      D.vehicles[k].forEach(function (l) { hs[l[0]] = 1; });
      var n = Object.keys(hs).length, from = 9999, to = 0;
      D.vehicles[k].forEach(function (l) { from = Math.min(from, l[1]); to = Math.max(to, l[2]); });
      counts[t] = counts[t] || {}; Object.keys(hs).forEach(function (x) { counts[t][x] = 1; });
      fam.push({ key: k, t: t, make: k.split('|')[1], model: k.split('|')[2], n: n, from: from, to: to });
    });
    fam.sort(function (a, b) { return b.n - a.n; });
    var typeCards = TYPES.map(function (t) {
      return '<button type="button" class="eagff-tcard" data-type="' + t[0] + '"><span class="eagff-tcard-ico">' + ICONS[t[0]] + '</span>' +
        '<span class="eagff-tcard-name">' + t[1] + '</span><span class="eagff-tcard-n">' + Object.keys(counts[t[0]] || {}).length + ' vehicle-specific parts</span>' +
        '<span class="eagff-tcard-go">Select vehicle &rarr;</span></button>';
    }).join('');
    function tiles(t) {
      return fam.filter(function (f) { return f.t === t; }).map(function (f) {
        return '<a class="eagff-vtile" href="' + esc(C.results + '?t=' + f.t + '&mk=' + encodeURIComponent(f.make) + '&md=' + encodeURIComponent(f.model)) + '">' +
          '<span class="eagff-vtile-mk">' + esc(f.make) + '</span><span class="eagff-vtile-md">' + esc(f.model) + '</span>' +
          '<span class="eagff-vtile-y">' + f.from + '&ndash;' + (f.to >= D.maxYear ? 'Up' : f.to) + '</span>' +
          '<span class="eagff-vtile-n">' + f.n + ' part' + (f.n === 1 ? '' : 's') + ' &rarr;</span></a>';
      }).join('');
    }
    out.innerHTML =
      '<div class="eagff-sec"><h2 class="eagff-sh">Shop by vehicle type</h2><div class="eagff-tcards">' + typeCards + '</div></div>' +
      '<div class="eagff-sec"><h2 class="eagff-sh">Popular vehicles</h2><div class="eagff-vtabs">' +
      TYPES.map(function (t, i) { return '<button type="button" class="eagff-vtab' + (i ? '' : ' is-on') + '" data-vt="' + t[0] + '">' + ICONS[t[0]] + ' ' + t[1] + '</button>'; }).join('') +
      '</div><div class="eagff-vtiles" data-eagff-vtiles>' + tiles('car') + '</div></div>' +
      '<div class="eagff-sec eagff-how"><div><b>1</b><strong>Select your vehicle</strong><span>Year, make and model. We save it in your garage.</span></div>' +
      '<div><b>2</b><strong>See parts that fit</strong><span>Custom enclosures, dash kits and integration parts made for it.</span></div>' +
      '<div><b>3</b><strong>Shop with confidence</strong><span>Every product page confirms fitment. Questions? <a href="tel:8772158187">(877) 215-8187</a></span></div></div>';
    out.querySelectorAll('.eagff-tcard').forEach(function (b) {
      b.addEventListener('click', function () {
        picker.type = b.getAttribute('data-type'); picker.sel = {}; picker.build();
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { var y = card.querySelector('.eagff-step-btn'); if (y) y.click(); }, 450);
      });
    });
    out.querySelectorAll('.eagff-vtab').forEach(function (b) {
      b.addEventListener('click', function () {
        out.querySelectorAll('.eagff-vtab').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        out.querySelector('[data-eagff-vtiles]').innerHTML = tiles(b.getAttribute('data-vt'));
      });
    });
  }

  function drawResults(out, prods, badge) {
    var types = {};
    prods.forEach(function (p) { var t = p.type || 'Other'; types[t] = (types[t] || 0) + 1; });
    var cur = 'all', sort = 'featured', stock = false;
    out.innerHTML = '';
    var bar = h('div', { class: 'eagff-toolbar' });
    var chips = h('div', { class: 'eagff-chips' });
    var tools = h('div', { class: 'eagff-tools', html:
      '<label class="eagff-stock"><input type="checkbox" data-stock> In stock only</label>' +
      '<label class="eagff-sort">Sort <select data-sort><option value="featured">Featured</option><option value="low">Price: low to high</option>' +
      '<option value="high">Price: high to low</option><option value="az">Name: A&ndash;Z</option></select></label>' });
    bar.appendChild(chips); bar.appendChild(tools);
    var grid = h('div', { class: 'eagff-grid' });
    tools.querySelector('[data-sort]').addEventListener('change', function (e) { sort = e.target.value; paint(); });
    tools.querySelector('[data-stock]').addEventListener('change', function (e) { stock = e.target.checked; paint(); });
    function chip(name, n) {
      return h('button', { type: 'button', class: 'eagff-chip' + (cur === name ? ' is-on' : ''), onclick: function () { cur = name; paint(); } },
        [(name === 'all' ? 'All' : name) + ' (' + n + ')']);
    }
    function paint() {
      chips.innerHTML = '';
      if (Object.keys(types).length > 1) {
        chips.appendChild(chip('all', prods.length));
        Object.keys(types).sort().forEach(function (t) { chips.appendChild(chip(t, types[t])); });
      }
      var list = prods.filter(function (p) { return (cur === 'all' || (p.type || 'Other') === cur) && (!stock || p.available); });
      list.sort(function (a, b) {
        if (b.available !== a.available) return b.available - a.available; // sold-out always last
        if (sort === 'low') return a.price - b.price;
        if (sort === 'high') return b.price - a.price;
        if (sort === 'az') return a.title.localeCompare(b.title);
        return (b.available - a.available) || a.title.localeCompare(b.title);
      });
      grid.innerHTML = list.length ? list.map(card).join('') : '<p class="eagff-empty-grid">No products match these filters.</p>';
    }
    function card(p) {
      var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
      var url = C.root + 'products/' + p.handle;
      var off = p.compare_at_price > p.price ? Math.round((1 - p.price / p.compare_at_price) * 100) : 0;
      return '<a class="eagff-card" href="' + esc(url) + '">' +
        '<span class="eagff-card-img">' + (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '') +
        (off ? '<span class="eagff-card-off">-' + off + '%</span>' : '') + (p.available ? '' : '<span class="eagff-card-so">Sold out</span>') + '</span>' +
        '<span class="eagff-fit">' + badge(p) + '</span>' +
        '<span class="eagff-card-v">' + esc(p.vendor) + '</span>' +
        '<span class="eagff-card-t">' + esc(p.title) + '</span>' +
        '<span class="eagff-card-p">' + money(p.price) +
        (off ? ' <s>' + money(p.compare_at_price) + '</s>' : '') + '</span>' +
        '<span class="eagff-card-cta">View product</span></a>';
    }
    out.appendChild(bar); out.appendChild(grid);
    out.appendChild(h('div', { class: 'eagff-more', html: '<div><strong>Looking for speakers, amps or subwoofers?</strong><p>Most of our audio gear is universal and works in any vehicle.</p></div>' +
      '<a class="eagff-hbtn" href="' + esc(C.shopAll) + '">Shop all products</a>' }));
    paint();
  }
  function emptyState(out, v) {
    out.innerHTML = '<div class="eagff-none"><h2>Universal parts for your ' + esc(label(v)) + '</h2><p>Our speakers, amplifiers and subwoofers are universal and work with your vehicle.</p>' +
      '<div class="eagff-hero-btns"><a class="eagff-hbtn" href="' + esc(C.shopAll) + '">Shop all products</a><button type="button" class="eagff-hbtn eagff-hbtn--dark" data-eagff-cant>Can\'t find your vehicle? Ask us</button></div></div>';
  }

  /* ---------- homepage bar ---------- */
  var barPickers = [];
  function bars() {
    document.querySelectorAll('[data-eagff-bar]').forEach(function (b) {
      barPickers.push(new Picker(b.querySelector('[data-eagff-bar-picker]'), { goText: b.getAttribute('data-go') || 'Find products', onDone: function (v) { location.href = resultsUrl(v); } }));
    });
  }

  /* ---------- wire up ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-eagff-wa]')) {
      e.preventDefault();
      var fab = document.querySelector('.eag-wa__fab');
      if (modal && !modal.hidden) closeModal();
      if (fab) setTimeout(function () { fab.click(); }, 0); else location.href = 'tel:8772158187';
      return;
    }
    var ob = t.closest('[data-eagff-open]');
    if (ob) { e.preventDefault(); openModal(ob.getAttribute('data-eagff-open') === 'check' ? 'check' : 'find'); return; }
    if (t.closest('[data-eagff-cant]')) { e.preventDefault(); (modal && !modal.hidden ? Promise.resolve() : openModal('find')).then(function () { showView('cant'); }); return; }
    if (modal && !modal.hidden) {
      if (t.closest('[data-eagff-close]')) { e.preventDefault(); closeModal(); return; }
      var vbtn = t.closest('[data-eagff-show]');
      if (vbtn) { e.preventDefault(); showView(vbtn.getAttribute('data-eagff-show')); return; }
      if (t.closest('[data-eagff-ignore]')) {
        e.preventDefault();
        try { sessionStorage.setItem(ignoredKey(), '1'); } catch (x) {}
        if (pending) resumeAtc(); closeModal(); return;
      }
    }
    var gm = t.closest('[data-eagff-gmore]');
    if (gm) {
      var open = gm.parentNode.classList.toggle('is-all');
      gm.textContent = open ? 'Show less' : 'Show more (' + gm.getAttribute('data-n') + ')';
      return;
    }
    if (t.closest('[data-eagff-shopwithout]')) { clearActive(); }
    if (!t.closest('.eagff-step')) {
      document.querySelectorAll('.eagff-step.is-open').forEach(function (w) {
        w.classList.remove('is-open'); var p = w.querySelector('.eagff-pop'); if (p) p.hidden = true;
      });
    }
  });
  document.addEventListener('submit', function (e) {
    if (e.target.closest && e.target.closest('#EagffCantForm')) { try { sessionStorage.setItem('eagff_cant_sent', '1'); } catch (x) {} }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closeModal(); });

  function init() {
    refresh();
    bars(); /* draw the bar straight away; options fill in once the data has loaded */
    var needData = C.product || C.listing || document.querySelector('[data-eagff-bar],[data-eagff-results]');
    if (needData) load().then(function () {
      refresh(); barPickers.forEach(function (p) { p.render(); });
      var r = document.querySelector('[data-eagff-results]'); if (r) results(r);
    });
    var sent = false; try { sent = sessionStorage.getItem('eagff_cant_sent'); sessionStorage.removeItem('eagff_cant_sent'); } catch (x) {}
    if (sent && /contact_posted=true/.test(location.search)) openModal('find').then(function () { showView('thanks'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.EAGFF = { open: openModal, active: active, fits: fits };
})();

/* Rebuy widget buttons labelled just "Add" (e.g. "Customers almost always add these") read
   "Add to Cart" like every other add button. Only an exact "Add" is changed, so Rebuy's own
   states ("Adding...", "Added!") still show. Rebuy redraws its widgets, so keep watching. */
(function eagRebuyAddLabel() {
  function fix(root) {
    (root || document).querySelectorAll('.rebuy-widget .rebuy-button span').forEach(function (sp) {
      if (sp.children.length === 0 && /^\s*add\s*$/i.test(sp.textContent)) sp.textContent = 'Add to Cart';
    });
  }
  var queued = false;
  function schedule() { if (queued) return; queued = true; setTimeout(function () { queued = false; fix(); }, 60); }
  function start() {
    fix();
    if (window.MutationObserver) new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Rebuy cart drawer: "Checkout • $X" -> "Proceed to Secure Checkout • $X" (Latif, Oct 16 cart audit).
   Only the label text node is rewritten (same node, so Rebuy's own re-renders keep working); the
   "• $X" part comes from CSS so phones can drop the price when it doesn't fit (see eag-ff.css). */
(function eagSecureCheckoutLabel() {
  function fix() {
    document.querySelectorAll('.rebuy-cart__checkout-button').forEach(function (btn) {
      // Rebuy writes either " Checkout • " + a price <span> (sale items in cart), or one text
      // " Checkout • $109.90" (no sale). In the second case the price moves to our own span.
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT), hits = [];
      for (var n = walker.nextNode(); n; n = walker.nextNode()) {
        if (!(n.parentNode && n.parentNode.classList && n.parentNode.classList.contains('eag-co-price'))) hits.push(n);
      }
      hits.forEach(function (n) {
        var m = n.nodeValue.match(/^\s*checkout\s*•?\s*(.*)$/i);
        if (!m) return;
        n.nodeValue = ' Proceed to Secure Checkout ';
        btn.classList.add('eag-secure-co');
        var price = m[1].trim(), ps = btn.querySelector('.eag-co-price');
        if (price) {
          if (!ps) { ps = document.createElement('span'); ps.className = 'eag-co-price'; n.parentNode.insertBefore(ps, n.nextSibling); }
          if (ps.textContent !== price) ps.textContent = price;
        } else if (ps) ps.remove();
      });
    });
  }
  var queued = false;
  function schedule() { if (queued) return; queued = true; setTimeout(function () { queued = false; fix(); }, 40); }
  function start() {
    fix();
    if (window.MutationObserver) new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Rebuy cart drawer top bar: the "happy customers" count -> "Serving Car Audio Since 2004"
   (Latif, Oct 16: customer-count claims make the business look smaller). Text set in Rebuy;
   swapped here so a Rebuy settings revert can't bring it back. */
(function eagRebuyTrustBar() {
  var RE = /10,?000\+?\s*happy\s*customers/i;
  function fix() {
    document.querySelectorAll('.rebuy-cart').forEach(function (cart) {
      var w = document.createTreeWalker(cart, NodeFilter.SHOW_TEXT);
      for (var n = w.nextNode(); n; n = w.nextNode()) {
        if (RE.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(RE, 'Serving Car Audio Since 2004');
      }
    });
  }
  var queued = false;
  function schedule() { if (queued) return; queued = true; setTimeout(function () { queued = false; fix(); }, 40); }
  function start() {
    fix();
    if (window.MutationObserver) new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
